import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { SellerConnectAdminSubmission } from 'models/SellerConnectEngine';
import { TRANSCRIPT_ROLE_LABELS } from '../../data';
import { getTranscriptMessages } from '../../utils';

import './SellerTranscript.styles.scss';

type SellerTranscriptProps = {
  className?: string;
  transcript: SellerConnectAdminSubmission['screening']['transcript'];
};

const SellerTranscript: React.FC<SellerTranscriptProps> = (props) => {
  const { className, transcript } = props;

  const { t } = useTranslation();

  const classes = classNames('seller-transcript', className);

  return (
    <ul className={classes}>
      {getTranscriptMessages(transcript).map(({ role, content }, index) => (
        <li key={index}>
          <span>{t(TRANSCRIPT_ROLE_LABELS[role])}</span>
          <p>{content}</p>
        </li>
      ))}
    </ul>
  );
};

export default SellerTranscript;
